export default "__VITE_ASSET__ZiYeAwgb__"